const STAFF_BACKEND_MESSAGE_TO_TRANSLATION_KEY: Record<string, string> = {
  "Employee number is already in use":
    "Staff.ProfilePanelErrorEmployeeNumberAlreadyInUse",
  "Selected start date is not allowed": "Staff.ProfilePanelErrorDateNotAllowed",
  "Worker not found": "Staff.ProfilePanelErrorWorkerNotFound",
  "Worker can not be edited": "Staff.ProfilePanelErrorWorkerCanNotBeEdited",
  "Employment overlaps with existing employment":
    "Staff.ProfilePanelErrorEmploymentOverlapsWithExistingEmployment",
  "Can not set date to before existing start date":
    "Staff.ProfilePanelErrorCanNotSetDateBeforeExistingStartDate",
  "Need to include one salary": "Staff.ProfilePanelErrorNeedToIncludeOneSalary",
  "Employment not found": "Staff.ProfilePanelErrorEmploymentNotFound",
  "Salary already exists": "Staff.ProfilePanelSalaryAlreadyExists",
  "Can not set date to before employment start date":
    "Staff.ProfilePanelErrorCanNotSetDateBeforeEmploymentStartDate",
  "Can not set date to after employment end date":
    "Staff.ProfilePanelErrorCanNotSetDateAfterEmploymentEndDate",
  "Tax already exists": "Staff.ProfilePanelErrorTaxAlreadyExists",
  "Need to have at least one employment":
    "Staff.ProfilePanelErrorNeedToHaveAtLeastOneEmployment",
  "Can not delete the first employment":
    "Staff.ProfilePanelErrorCanNotDeleteTheFirstEmployment",
  "Employment cannot start in the same month as a previous employment ends":
    "Staff.ProfilePanelErrorEmploymentCannotStartInSameMonthAsPreviousEmploymentEnds",
  "Need to have at least one salary":
    "Staff.ProfilePanelErrorNeedToHaveAtLeastOneSalary",
  "Salary not found": "Staff.ProfilePanelErrorSalaryNotFound",
  "Can not delete the first salary":
    "Staff.ProfilePanelErrorCanNotDeleteTheFirstSalary",
  "Need to have at least one tax":
    "Staff.ProfilePanelErrorNeedToHaveAtLeastOneTax",
  "Tax not found": "Staff.ProfilePanelErrorTaxNotFound",
  "Can not delete the first tax":
    "Staff.ProfilePanelErrorCanNotDeleteTheFirstTax",
  "Invalid payment method type": "Staff.PaymentMethodTypeInvalid",
};

/**
 * The translation key for a message the staff endpoints answer with, or null
 * when the message is not one the app explains.
 */
export const toStaffBackendErrorTranslationKey = (
  backendMessage: string | null | undefined,
): string | null => {
  if (!backendMessage) return null;
  return STAFF_BACKEND_MESSAGE_TO_TRANSLATION_KEY[backendMessage] ?? null;
};
